module.exports = __webpack_public_path__ + "GooglePixel3-Pink@2x.png?65c56abb80390e06981f5aeb858ec6fc";